import addGclid from '../gclid'

const conversationFlow = [
    {
        matches: [{ code: "welcome", regex: [/./s] }],
        code: "preguntaNombre",
        callback: (incomingMessage, storedData, updateConversationStoredData) => {
            const newData = { ...storedData }
            newData.nombre = incomingMessage
            updateConversationStoredData(newData)
            return [<p className="BotonFlotante-botMessage">Gracias <b>{incomingMessage}</b>.<br />¿Cuál es tu número de teléfono?</p>]
        }
    },
    {
        matches: [{ code: "preguntaNombre", regex: [/./s] }],
        code: "preguntaTelefono",
        callback: (incomingMessage, storedData, updateConversationStoredData) => {
            const newData = { ...storedData }
            newData.telefono = incomingMessage
            updateConversationStoredData(newData)
            return [<p className="BotonFlotante-botMessage">Ahora ingresá tu dirección completa, por favor (dirección, entre calles, localidad, código postal).</p>]
        }
    },
    {
        matches: [{ code: "preguntaTelefono", regex: [/./s] }],
        fallbackMessages: [<p className="BotonFlotante-botMessage">En breve te vamos a enviar toda la información al número que nos brindaste 🙂</p>],
        code: "preguntaDireccion",
        callback: (incomingMessage, storedData, updateConversationStoredData) => {
            const newData = { ...storedData }
            newData.localidad = incomingMessage
            newData.origen = '/fibraoptica chat'
            newData.gclid = addGclid()
            updateConversationStoredData(newData)

            window.enhanced_conversion_data.phone_number = newData.telefono

            const jsonData = JSON.stringify(newData)

            let integromatRequest = new XMLHttpRequest()
            integromatRequest.open('POST', 'https://hook.us1.make.com/t49vtz5fpyqxr5nxdbnn9h1bk2ry1lye')

            let newsletterServiceRequest = new XMLHttpRequest()
            newsletterServiceRequest.open('POST', 'https://newsletterservice.com.ar/landing/api/infinitfibra')
            newsletterServiceRequest.setRequestHeader('Content-Type', 'application/json')
            newsletterServiceRequest.send(jsonData)

            integromatRequest.setRequestHeader('Content-Type', 'application/json')
            integromatRequest.send(jsonData)

            window.gtag('event', 'conversion', { 'send_to': 'AW-652151810/XLQqCLCp5s0BEIKY_LYC' })
            window.fbq('track', 'Lead')
            window.gtag('event', 'leadForm')

            return [<p className="BotonFlotante-botMessage">Gracias, en breve te vamos a enviar toda la información al número que nos brindaste 🙂</p>]
        }
    }
]

export default conversationFlow